module.exports = __webpack_public_path__ + "img/case-logo-23.c8629893.png";